// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1xdkk","calendarButtons":"ClockData_calendarButtons__2QxSP"};